import { useState } from "react";
import clsx from "clsx";
import { Button, Col, ModalProps, Row, useModal } from "@commonlibs";
import { createModal } from "@commonlibs";
import type { LocalGiftCardDto } from "common/models/api/models/LocalGiftCardDto";
import { GiftcardVoucherModalRoot } from "./GiftcardVoucherModal.styles";
import useTranslate from "ui/locale/hooks/useTranslate";
import Spinner from "ui/common/components/feedback/SpinnerCircle/SpinnerCircle";
import usePreviewVoucher from "features/giftcards/hooks/usePreviewVoucher";

type VoucherStatus = "COMPLETED" | "PENDING";

const GiftcardVoucherModal = createModal<{ giftCard: LocalGiftCardDto } & ModalProps>(({ className, giftCard, ...rest }) => {
    const translate = useTranslate();
    const translateError = useTranslate("error");
    const { hideModal } = useModal();
    const [status, setStatus] = useState<VoucherStatus>("COMPLETED");

    const { data: html, isLoading, isError } = usePreviewVoucher({ allyId: giftCard.partner.address, status });

    function closeModal() {
        hideModal(GiftcardVoucherModal.id);
    }

    function handleStatusChange(nextStatus: VoucherStatus) {
        setStatus(nextStatus);
    }

    return (
        <GiftcardVoucherModalRoot
            title={translate("giftCardVoucherModel")}
            className={clsx("giftcard-voucher-modal", className)}
            style={{ width: "550px", padding: "0px" }}
            {...rest}
        >
            <Col gap={15}>
                <Row justifyContent="center" gap={10}>
                    <Button
                        onClick={() => handleStatusChange("COMPLETED")}
                        variant={status === "COMPLETED" ? "primary" : "outlined"}
                        style={{ width: "150px" }}
                    >
                        {translate("active")}
                    </Button>
                    <Button
                        onClick={() => handleStatusChange("PENDING")}
                        variant={status === "PENDING" ? "primary" : "outlined"}
                        style={{ width: "150px" }}
                    >
                        {translate("pending")}
                    </Button>
                </Row>

                {isLoading && (
                    <Row justifyContent="center" alignItems="center" style={{ height: "400px" }}>
                        <Spinner size={30} />
                    </Row>
                )}

                {!isLoading && isError && (
                    <Row justifyContent="center" alignItems="center" style={{ height: "400px" }}>
                        {translateError("somethingWentWrong")}
                    </Row>
                )}

                {!isLoading && !isError && html && (
                    <iframe
                        srcDoc={html}
                        sandbox=""
                        style={{ width: "100%", height: "500px", border: "none" }}
                        title={translate("giftCardVoucherModel")}
                    />
                )}
            </Col>
            <Row justifyContent="center" style={{ marginTop: "15px" }}>
                <Button onClick={closeModal} variant="primary" style={{ width: "200px" }}>
                    {translate("accept")}
                </Button>
            </Row>
        </GiftcardVoucherModalRoot>
    );
});

export default GiftcardVoucherModal;
